import constWorld from "./constworld";

const terrainNames = [
    'water',
    'plains',
    'forest',
    'hills',
    'mountain',
    'coast',
    'river'
];

const makeWorld = (grid, width, height) => {
    const { terrain, uniqueResources } = constWorld.getRandomWorld();
    const claimed = Array(width * height).fill(false);
    const advancements = Array(width * height);
    let untouchedClaimedCount = 0;
    let advancementClaimedCount = 0;
    let untouchedResourceClaimedCount = 0;

    const world = {
        advance: (u, v, newAdvancement) => {
            const index = grid.getArrayIndex(u, v);
            const prevAdvancement = advancements[index];
            advancements[index] = newAdvancement;
            if (prevAdvancement === undefined) {
                advancementClaimedCount += 1;
                if (world.getUniqueResource(u, v)) {
                    untouchedResourceClaimedCount -= 1;
                } else {
                    untouchedClaimedCount -= 1;
                }
            }
        },

        removeAdvancements: (u, v) => {
            const index = grid.getArrayIndex(u, v);
            const prevAdvancement = advancements[index];
            advancements[index] = undefined;
            if (prevAdvancement) {
                advancementClaimedCount -= 1;
                if (world.getUniqueResource(u, v)) {
                    untouchedResourceClaimedCount += 1;
                } else {
                    untouchedClaimedCount += 1;
                }
            }
        },

        claim: (u, v) => {
            const index = grid.getArrayIndex(u, v);
            claimed[index] = true;
            if (world.getUniqueResource(u, v)) {
                untouchedResourceClaimedCount += 1;
            } else {
                untouchedClaimedCount += 1;
            }
        },

        getTerrain: (u, v) => {
            return terrainNames[terrain[grid.getArrayIndex(u, v)]];
        },

        getUniqueResource: (u, v) => {
            return (uniqueResources.find(r => r.u === u && r.v === v) || {}).resource;
        },

        getAdvancement: (u, v) => {
            return advancements[grid.getArrayIndex(u, v)];
        },

        isClaimed: (u, v) => {
            return claimed[grid.getArrayIndex(u, v)];
        },

        getClaimedCount: () => untouchedClaimedCount + untouchedResourceClaimedCount + advancementClaimedCount,

        getUntouchedClaimedCount: () => untouchedClaimedCount,

        getAdvancementClaimedCount: () => advancementClaimedCount,

        getUntouchedResourceClaimedCount: () => untouchedResourceClaimedCount
    };

    return world;
};

export default makeWorld;